// extracted by mini-css-extract-plugin
module.exports = {"gift_rule":"index-gift_rule-gY3d1"};